<template>
    <v-dialog
        content-class="eldWrapper"
        v-model="isEldPopup"
        width="880"
        persistent
    >
        <v-card class="eldBg">
            <v-card-title class="headline lighten-2">
                <div class="actionHeader">
                    <span>ELD</span>
                    <div class="actionHeader_right">
                        <button @click="onClose">
                            <svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
                        </button>
                    </div>
                </div>
                <div class="actionBody">
                    <div class="groupField_wrap">
                        <field
                            :classError="$v.eld_name.$error"
                            margin="10px 10px 0 0"
                            width="200px"
                            height="60px"
                            label="ELD name"
                            placeholder="Enter name"
                            :setInputValue="eld_name"
                            @updateInput="onInput($event, 'eld_name')"
                            is-required
                        ></field>
                        <field
                            :classError="$v.eld_url.$error"
                            margin="10px 10px 0 0"
                            width="200px"
                            height="60px"
                            label="URL"
                            placeholder="Enter URL"
                            :setInputValue="eld_url"
                            @updateInput="onInput($event, 'eld_url')"
                            is-required
                            is-clip
                            is-link
                        ></field>
                        <field
                            :classError="$v.eld_login.$error"
                            margin="10px 10px 0 0"
                            width="200px"
                            height="60px"
                            label="Login"
                            placeholder="Enter login"
                            :setInputValue="eld_login"
                            @updateInput="onInput($event, 'eld_login')"
                            is-required
                            is-clip
                        ></field>
                        <field
                            :classError="$v.eld_password.$error"
                            margin="10px 10px 0 0"
                            width="200px"
                            height="60px"
                            type="password"
                            label="Password"
                            placeholder="Enter Password"
                            :setInputValue="eld_password"
                            @updateInput="onInput($event, 'eld_password')"
                            is-required
                            is-clip
                            is-pass
                        ></field>
                    </div>
                </div>
                <div class="actionBottom">
                    <button-groups @updateBtnClose="onClose" @updateSave="onEldSave"></button-groups>
                </div>
            </v-card-title>
        </v-card>
    </v-dialog>
</template>

<script>
// components
import ButtonGroups from "@/shared/ButtonGroups/ButtonGroups";
import { required, url } from "vuelidate/lib/validators";
// validate
import { validationMixin } from "vuelidate";

export default {
	name: "EldPopup",
	mixins: [ validationMixin ],
	components: {
		ButtonGroups
	},
	props: {
		item: Object
	},
	data: () => ({
		isEldPopup: true,
		eld_name: '',
		eld_url: '',
		eld_login: '',
		eld_password: ''
	}),
	methods: {
		onEldSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const values = {
					eld_name: this.eld_name,
					eld_url: this.eld_url,
					eld_login: this.eld_login,
					eld_password: this.eld_password,
				};
				this.$emit('updateEld', values);
			}

		},
		onClose() {
			this.$emit('updateCloseEldPopup');
		},
		onInput({ value }, key) {
			this[key] = value;
		}
	},
	validations: {
		eld_name: { required },
		eld_url: { required, url },
		eld_login: { required },
		eld_password: { required }
	},
	mounted() {
		const { eld_name, eld_url, eld_login, eld_password } = this.item;
		this.eld_name = eld_name;
		this.eld_url = eld_url;
		this.eld_login = eld_login;
		this.eld_password = eld_password;
	}
};
</script>

<style scoped lang="scss">
@import "EldPopup";
</style>
